import {close_modal, loading} from "../functions/functions";

export function show_edit_expert_modal()
{
    if( document.querySelectorAll('.js_show_front_expert_users_button') ) {
        document.querySelectorAll('.js_show_front_expert_users_button').forEach( edit_expert => {
            edit_expert.addEventListener('click', ev => {
                ev.preventDefault();
                document.querySelector('.experts_modal_container.js_edit_modal').classList.add('show_modal');
                    document.querySelector('.js_username_show').innerText = edit_expert.dataset.username;
                    document.querySelector('.body.js_edit_modal').innerHTML = loading();
                    jQuery.ajax({
                        url: edit_expert.dataset.url,
                        method: "POST",
                        data: {
                            action: edit_expert.dataset.action,
                            nonce: edit_expert.dataset.nonce,
                            userid: edit_expert.dataset.userid,
                            username: edit_expert.dataset.username,
                        },
                        error: (res) => {
                            console.log("ERROR RES :");
                            console.log(res);
                        },
                        success: (res) => {
                            document.querySelector('.body.js_edit_modal').innerHTML = res;
                        }
                    });
            });
        });
        close_modal();
    }
}